import React from 'react';
export function VolumesDetail() {
  const volumes = [{
    vol: '📘 Tomo 1 — 1° Grado:',
    title: 'Yo, mi familia y mi entorno',
    content: 'Identidad, familia, vecindario'
  }, {
    vol: '📗 Tomo 2 — 2° Grado:',
    title: 'Mi barrio y mi ciudad',
    content: 'Espacio urbano, servicios, comunidad'
  }, {
    vol: '📙 Tomo 3 — 3° Grado:',
    title: 'Vivir en sociedad',
    content: 'Normas, instituciones, trabajo'
  }, {
    vol: '📕 Tomo 4 — 4° Grado:',
    title: 'Argentina: territorio y diversidad',
    content: 'Geografía argentina, regiones, recursos'
  }, {
    vol: '📓 Tomo 5 — 5° Grado:',
    title: 'Historia argentina',
    content: 'Procesos históricos, independencia, nación'
  }, {
    vol: '📔 Tomo 6 — 6° Grado:',
    title: 'Argentina en el mundo',
    content: 'Latinoamérica, globalización, ciudadanía'
  }];
  const includes = ['Planificación anual lista para presentar al directivo', '4 unidades didácticas completas con todas las clases del año', 'Secuencias didácticas paso a paso con inicio–desarrollo–cierre', 'Actividades listas para imprimir y usar en el aula', 'Evaluación diagnóstica + 3 evaluaciones trimestrales', 'SOLUCIONARIO COMPLETO con todas las respuestas correctas', 'Rúbricas de evaluación oral y escrita', 'Autoevaluación del alumno incluida en cada unidad', 'Mapas y recursos visuales listos para usar en clase', 'Efemérides argentinas integradas en el año escolar', '100% alineado NAP Argentina + Diseños Curriculares provinciales', 'Bibliografía oficial al finalizar cada tomo'];
  return <section className="bg-brand-dark py-24 px-4 border-t border-brand-border" data-id="element-248">
      <div className="max-w-5xl mx-auto" data-id="element-249">
        <h2 className="text-4xl md:text-5xl font-heading font-bold text-center text-white mb-16" data-id="element-250">
          LO QUE <span className="text-brand-accent" data-id="element-251">RECIBÍS</span>
        </h2>

        <div className="max-w-3xl mx-auto flex flex-col gap-8 mb-20" data-id="element-252">
          <div className="bg-brand-card border border-brand-accent/40 rounded-2xl p-6 md:p-8" data-id="element-253">
            <div className="mb-8 text-center" data-id="element-254">
              <h3 className="text-2xl md:text-3xl font-heading font-bold uppercase mb-2 text-brand-accent" data-id="element-255">
                📚 Los 6 Tomos de Sociales
              </h3>
              <p className="text-white/70 text-base" data-id="element-256">
                Para docentes de Ciencias Sociales de 1.º a 6.º grado de
                primaria
              </p>
            </div>
            <div className="space-y-6" data-id="element-257">
              {volumes.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-258">
                  <p className="text-white/90 text-base leading-relaxed" data-id="element-259">
                    <span className="font-bold text-white mr-2 block md:inline" data-id="element-260">
                      {item.vol}
                    </span>
                    <span className="italic text-white/80 block md:inline md:mr-2" data-id="element-261">
                      {item.title}
                    </span>
                    <span className="text-white/70 text-sm block mt-1 md:mt-0" data-id="element-262">
                      ({item.content})
                    </span>
                  </p>
                </div>)}
            </div>
          </div>
        </div>

        <div className="max-w-3xl mx-auto bg-brand-card rounded-2xl p-8 md:p-12 border-2 border-brand-accent/40" data-id="element-263">
          <h3 className="text-2xl md:text-3xl font-heading font-bold mb-8 md:mb-10 text-center text-brand-accent" data-id="element-264">
            Cada tomo incluye:
          </h3>
          <div className="flex flex-col gap-5 md:gap-6" data-id="element-265">
            {includes.map((item, i) => <div key={i} className="flex items-start gap-4" data-id="element-266">
                <div className="flex-shrink-0 w-8 h-8 bg-[#0097A7] rounded-md flex items-center justify-center mt-0.5 text-white font-black" data-id="element-267">
                  ✓
                </div>
                <span className="font-bold text-white text-lg md:text-xl leading-snug" data-id="element-268">
                  {item}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}